import React from "react";
import "./Footer.scss";
import { Image } from "react-bootstrap";
import { discord, fb, mobLogo, twitter } from "assets/images";

const Footer = () => {
  return (
    <footer id="footer">
      <div className="top">
        <Image
          src={mobLogo}
          alt="virtua token"
          className="logo"
          fluid
        />

        <ul className="socials mb-0">
          <li>
            <a href="https://web.facebook.com/VirtuaMetaverse/" target="_blank" rel="noreferrer">
              <Image
                src={fb}
                fluid
              />
            </a>
          </li>

          <li>
            <a href="https://discord.com/invite/virtua" target="_blank" rel="noreferrer">
              <Image
                src={discord}
                fluid
              />
            </a>
          </li>

          <li>
            <a href="https://twitter.com/Virtuametaverse" target="_blank" rel="noreferrer">
              <Image
                src={twitter}
                fluid
              />
            </a>
          </li>
        </ul>
      </div>
      <Image
        src={process.env.REACT_APP_S3_IMAGE_PATH + "line.svg"}
        className="borderLine"
        fluid
      />
      <div className="bottom">
        <p className="mb-0">
          Copyright © {new Date().getUTCFullYear()} Virtua
        </p>
        <a href={process.env.REACT_APP_PRIVACY_POLICY_URL} target="_blank" rel="noreferrer">Privacy Policy</a>
      </div>
    </footer>
  );
};

export default Footer;
